/**
 * FilmIQ Platform v3 - Firebase Configuration
 * 
 * Uses environment variables for production-specific Firebase settings.
 * See .env.template for required variables.
 */

import { initializeApp, FirebaseApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, EmailAuthProvider } from "firebase/auth";
import { getAnalytics, logEvent, Analytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { firebaseConfig, featureFlags, validateConfig } from "./config";

// Validate configuration on startup
const configValidation = validateConfig();
if (!configValidation.valid) {
  console.error('Firebase configuration errors:', configValidation.errors);
}

// Initialize Firebase with environment-based config
const app: FirebaseApp = initializeApp(firebaseConfig);

// Initialize Auth
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const emailProvider = new EmailAuthProvider();

// Initialize Firestore (for chat history persistence)
export const db = getFirestore(app);

// Initialize Analytics (only if enabled and config is valid)
let analytics: Analytics | null = null;
if (featureFlags.enableAnalytics && firebaseConfig.measurementId) {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.warn('Firebase Analytics initialization failed:', error);
  }
}

export { analytics };

// Helper to log custom events (only if analytics is enabled)
export const logAnalyticsEvent = (eventName: string, eventParams?: Record<string, any>) => {
  if (analytics) {
    logEvent(analytics, eventName, eventParams);
  }
};

export default app;
